import React from 'react';
import Home from './components/Home';
import Profile from './components/Profile';
import NoMatch from './components/NoMatch';
import {Route, Switch} from "react-router-dom";
import logo from './assets/img/logo.png';
import { AsyncStorage } from 'AsyncStorage';
import {connect} from 'react-redux';
import {CONFIG} from './config/default';
import axios from 'axios';
import {signInAction} from './actions';
import Zoom from 'react-reveal/Zoom';
class App extends React.Component{
    constructor(props){
        super(props);
        //this._bootstrapAsync();
        this.state = {
            loaded: true
        };
    }
    componentDidMount(){

    }
    render() {
      return (this.state.loaded?
          <Switch>
              <Route component={Home} exact path={`/`} />
              <Route component={Profile} path={`/profile`} />
              <Route component={NoMatch} />
          </Switch>
              : <div className={`loading-div`}>
                  <p><Zoom><img src={logo} alt="App Logo"/></Zoom></p>
              </div>
      );
  }
    _bootstrapAsync = async () => {
        AsyncStorage.getItem('@BearerAccessToken').then((token) => {
            if(token !== undefined){

            }else{
                this.setState({
                    loaded: true
                });
            }
        });
    };
}

const mapStateToProps = (state, ownProps) => {
    return {
        state
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        onLogin: (id, name, email, token, phone, userData, tasks) => {
            dispatch(signInAction(id, name, email, token, phone, userData, tasks));
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(App);